import RootContext from './RootContext'

export { RootContext }

const contextService = {
  RootContext
}

export default contextService
